
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/on-sale",
      function () {
        return require("private-next-pages/on-sale.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/on-sale"])
      });
    }
  